import { render, staticRenderFns } from "./ServersPage.vue?vue&type=template&id=21b3cc40&"
import script from "./ServersPage.vue?vue&type=script&lang=js&"
export * from "./ServersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports